import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import Select from "../../form/Select";

class InvoicingList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }
    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "InvoicingList"}
                {...props}
                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                columns={{
                    [this.props.componentConfig.idfield]: {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "customer.name": {
                        header: 'Vevő',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "transactiondate": {
                        header: 'Tranzakció dátuma',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "startdate": {
                        header: 'Időszak',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "enddate": {
                        header: 'vége',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "state": {
                        header: 'Státusz',
                        width: 1,
                        sortable,
                        renderer: (value) => ([
                            {key: "0", label: "Mentve"},
                            {key: "30", label: "Számlázva"},
                            {key: "90", label: "Törölve"},
                        ].find((option) => option.key + "" === value) || {}).label,
                        filterable: <Select
                            storeType="local"
                            options={[
                                {key: "0", label: "Mentve"},
                                {key: "30", label: "Számlázva"},
                                {key: "90", label: "Törölve"},
                            ]}
                            label={false}
                            objectValue={false}
                            isClearable={true}
                            valueKey="key"
                            labelKey="label"
                        />
                    }
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default InvoicingList;
